<template>
  <div>
  <div class="sidebar-overlay" @click="closeSidebar">
    <div
      class="sidebar-main"
      @click.stop
      :class="[isVisible ? 'slide-in' : 'slide-out']"
    >
      <div class="sidebar-body">
        <div class="nav-item-custom">
          <router-link
            id="linkFaq"
            to="/faq"
            class="a-sidebar"
            @click.native="closeSidebar"
          >
            Central de ajuda
          </router-link>
        </div>

        <div
          class="nav-item-custom"
          v-has-permission.permission="['EVT', 'VI']"
        >
          <router-link
            id="linkNotification"
            class="a-sidebar"
            to="/notification"
            @click.native="closeSidebar"
          >
            Notificações</router-link
          >
        </div>
        <div
          class="nav-item-custom"
        >
          <a id="appInstall" href="#" class="a-sidebar" @click.prevent="handleAppInstallClick">{{ appInstallLabel }}</a>
        </div>

        <span v-has-permission.permission="['PAG', 'VI']">
          <div class="dropdown-divider _divider-menu"></div>
          <div class="nav-item-custom">
            <router-link
              id="linkPayments"
              class="a-sidebar"
              to="/payments"
              @click.native="closeSidebar"
            >
              Pagamentos</router-link
            >
          </div>
        </span>

        <span v-has-permission.permission="['AVA', 'VI']" class="m-w20 mb-3">
          <div class="nav-item-custom">
            <router-link
              id="linkViability"
              class="a-sidebar"
              to="/viability"
              @click.native="closeSidebar"
            >
              Viabilidade</router-link
            >
          </div>
        </span>

        <span v-has-permission.permission="['ATI', 'VI']" class="m-w20 mb-3">
          <div class="nav-item-custom">
            <router-link
              id="linkActivation"
              class="a-sidebar"
              to="/activation"
              @click.native="closeSidebar"
            >
              Ativação</router-link
            >
          </div>
        </span>

        <!-- <span v-has-permission.permission="['OLT', 'VI']" class="m-w20 mb-3">
          <div class="nav-item-custom">
            <router-link
              id="linkOlts"
              class="a-sidebar"
              to="/oltModule"
              @click.native="closeSidebar"
            >
              OLT</router-link
            >
          </div>
        </span> -->

        <span v-has-permission.permission="['LOG', 'VI']" class="m-w20 mb-3">
          <div class="nav-item-custom">
            <router-link
              id="linkLogging"
              class="a-sidebar"
              to="/logging"
              @click.native="closeSidebar"
            >
              Auditoria</router-link
            >
          </div>
        </span>

        <span v-has-permission.permission="['AMA', 'VI']">
          <div class="dropdown-divider _divider-menu"></div>
          <div class="accordion-custom" role="tablist">
            <div class="card-custom mb-1" id="linkMapa">
              <div class="card-header-custom p-1" role="tab">
                <button
                  id="btnMap"
                  class="btn btn-transparent sidebar-button d-flex justify-content-between w-100 px-0"
                  type="button"
                  @click="visible = !visible"
                  aria-expanded="false"
                >
                  <span>Mapa</span>
                  <i
                    v-if="visible"
                    class="fa fa-chevron-down"
                    style="color: #fff"
                    aria-hidden="true"
                  ></i>
                  <i
                    v-else
                    class="fa fa-chevron-up"
                    style="color: #fff"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
              <div class="collapse-content" :class="{ show: visible }">
                <div class="card-body-custom">
                  <div
                    class="nav-item-custom"
                    v-has-permission.permission="['CFB', 'VI']"
                  >
                    <router-link
                      id="linkManufacturer"
                      class="a-sidebar"
                      to="/manufacturer"
                      @click.native="closeSidebar"
                    >
                      Fabricante
                    </router-link>
                  </div>
                  <div
                    class="nav-item-custom"
                    v-has-permission.permission="['CMB', 'VI']"
                  >
                    <router-link
                      id="linkCableModel"
                      class="a-sidebar"
                      to="/cablemodel"
                      @click.native="closeSidebar"
                    >
                      Modelo de cabo</router-link
                    >
                  </div>
                  <div
                    class="nav-item-custom"
                    v-has-permission.permission="['CMC', 'VI']"
                  >
                    <router-link
                      id="linkConectorModel"
                      class="a-sidebar"
                      to="/conectormodel"
                      @click.native="closeSidebar"
                    >
                      Modelo de conector</router-link
                    >
                  </div>
                  <div
                    class="nav-item-custom"
                    v-has-permission.permission="['CMS', 'VI']"
                  >
                    <router-link
                      id="linkSplitterModel"
                      class="a-sidebar"
                      to="/splittermodel"
                      @click.native="closeSidebar"
                    >
                      Modelo de splitter</router-link
                    >
                  </div>
                  <div
                    class="nav-item-custom"
                    v-has-permission.permission="['SMO', 'VI']"
                  >
                    <router-link
                      id="linkSwitchModel"
                      class="a-sidebar"
                      to="/switchmodel"
                      @click.native="closeSidebar"
                    >
                      Modelo de switch</router-link
                    >
                  </div>

                  <div
                    class="nav-item-custom"
                    v-has-permission.permission="['CME', 'VI']"
                  >
                    <router-link
                      id="linkAmendmentModel"
                      class="a-sidebar"
                      to="/amendmentmodel"
                      @click.native="closeSidebar"
                    >
                      Modelo de caixa de emendas</router-link
                    >
                  </div>
                  <div
                    class="nav-item-custom"
                    v-has-permission.permission="['CMT', 'VI']"
                  >
                    <router-link
                      id="linkCtoModel"
                      class="a-sidebar"
                      to="/ctomodel"
                      @click.native="closeSidebar"
                    >
                      Modelo de CTO</router-link
                    >
                  </div>
                  <div
                    class="nav-item-custom"
                    v-has-permission.permission="['CMO', 'VI']"
                  >
                    <router-link
                      id="linkOltModel"
                      class="a-sidebar"
                      to="/oltmodel"
                      @click.native="closeSidebar"
                    >
                      Modelo de OLT</router-link
                    >
                  </div>
                  <div
                    class="nav-item-custom"
                    v-has-permission.permission="['CMP', 'VI']"
                  >
                    <router-link
                      id="linkBoardModel"
                      class="a-sidebar"
                      to="/boardmodel"
                      @click.native="closeSidebar"
                    >
                      Modelo de placa</router-link
                    >
                  </div>
                  <div
                    class="nav-item-custom"
                    v-has-permission.permission="['CMD', 'VI']"
                  >
                    <router-link
                      id="linkDioModel"
                      class="a-sidebar"
                      to="/diomodel"
                      @click.native="closeSidebar"
                    >
                      Modelo de DIO</router-link
                    >
                  </div>
                  <div
                    class="nav-item-custom"
                    v-has-permission.permission="['CML', 'VI']"
                  >
                    <router-link
                      id="linkCordoalhaModel"
                      class="a-sidebar"
                      to="/cordoalhamodel"
                      @click.native="closeSidebar"
                    >
                      Modelo de cordoalha</router-link
                    >
                  </div>
                  <div
                    class="dropdown-divider _divider-menu"
                    v-has-permission.permission="['CKF', 'VI']"
                  ></div>
                  <div
                    class="nav-item-custom"
                    v-has-permission.permission="['CKF', 'VI']"
                  >
                    <router-link
                      id="linkHardwareKit"
                      class="a-sidebar"
                      to="/hardwarekit"
                      @click.native="closeSidebar"
                    >
                      Kits de ferragens</router-link
                    >
                  </div>
                  <div
                    class="nav-item-custom"
                    v-has-permission.permission="['CKF', 'VI']"
                  >
                    <router-link
                      id="linkHardwareItems"
                      class="a-sidebar"
                      to="/hardwareitems"
                      @click.native="closeSidebar"
                    >
                      Itens de ferragens</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </span>

        <span v-has-permission.permission="['AMA', 'VI']">
          <div class="dropdown-divider _divider-menu"></div>

          <div
            class="nav-item-custom"
            v-has-permission.permission="['COE', 'VI']"
          >
            <router-link
              id="linkConfigurationCompany"
              class="a-sidebar"
              to="/configurationcompany"
              @click.native="closeSidebar"
            >
              Configurações</router-link
            >
          </div>
          <!-- <div
            class="nav-item-custom"
            v-has-permission.permission="['VSN', 'VI']"
          >
            <router-link
              id="linkSnbind"
              class="a-sidebar"
              to="/snbind"
              @click.native="closeSidebar"
            >
              Vincular SN</router-link
            >
          </div> -->
        </span>

        <div class="dropdown-divider _divider-menu"></div>
        <div class="nav-item-custom">
          <router-link
            id="linkChangepassword"
            class="a-sidebar"
            to="/changepassword"
            @click.native="closeSidebar"
          >
            Alterar senha do usuário</router-link
          >
        </div>
        <div
          class="nav-item-custom"
          v-has-permission.permission="['USU', 'VI']"
        >
          <router-link
            id="linkUser"
            class="a-sidebar"
            to="/user"
            @click.native="closeSidebar"
          >
            Usuários</router-link
          >
        </div>
        <div
          class="nav-item-custom"
          v-has-permission.permission="['PRO', 'VI']"
        >
          <router-link
            id="linkprofile"
            class="a-sidebar"
            to="/profile"
            @click.native="closeSidebar"
          >
            Perfil</router-link
          >
        </div>
        <div
          class="nav-item-custom"
          v-has-permission.permission="['AIP', 'VI']"
        >
          <router-link
            id="linkIp"
            class="a-sidebar"
            to="/ip"
            @click.native="closeSidebar"
          >
            IP</router-link
          >
        </div>

        <div class="dropdown-divider _divider-menu"></div>
        <div
          class="nav-item-custom"
          v-has-permission.permission="['RER', 'VI']"
        >
          <router-link
            id="linkWebReport"
            class="a-sidebar"
            to="/webreport"
            @click.native="closeSidebar"
          >
            Relatório da rede</router-link
          >
        </div>
        <div
          class="nav-item-custom"
          v-has-permission.permission="['RET', 'VI']"
        >
          <router-link
            id="linkCtoReport"
            class="a-sidebar"
            to="/ctoreport"
            @click.native="closeSidebar"
          >
            Relatório de CTO's</router-link
          >
        </div>
        <div
          class="nav-item-custom"
          v-has-permission.permission="['REO', 'VI']"
        >
          <router-link
            id="linkCeoReport"
            class="a-sidebar"
            to="/ceoreport"
            @click.native="closeSidebar"
          >
            Relatório de CEO's</router-link
          >
        </div>
        <div
          class="nav-item-custom"
          v-has-permission.permission="['REC', 'VI']"
        >
          <router-link
            id="linkClientReport"
            class="a-sidebar"
            to="/clientreport"
            @click.native="closeSidebar"
          >
            Relatório de clientes</router-link
          >
        </div>
        <div
          class="nav-item-custom"
          v-has-permission.permission="['RPO', 'VI']"
        >
          <router-link
            id="linkPoleReport"
            class="a-sidebar"
            to="/polereport"
            @click.native="closeSidebar"
          >
            Relatório de postes</router-link
          >
        </div>
        <div
          class="nav-item-custom"
          v-has-permission.permission="['REI', 'VI']"
        >
          <router-link
            id="linkClientSignalReport"
            class="a-sidebar"
            to="/clientsignalreport"
            @click.native="closeSidebar"
          >
            Relatório de sinal</router-link
          >
        </div>
        <div
          class="nav-item-custom"
          v-has-permission.permission="['REB', 'VI']"
        >
          <router-link
            id="linkCableReport"
            class="a-sidebar"
            to="/cablereport"
            @click.native="closeSidebar"
          >
            Relatório de cabos</router-link
          >
        </div>
        <div
          class="nav-item-custom"
          v-has-permission.permission="['REV', 'VI']"
        >
          <router-link
            id="linkCondominiumReport"
            class="a-sidebar"
            to="/condominiumreport"
            @click.native="closeSidebar"
          >
            Relatório de condomínios</router-link
          >
        </div>
        <div
          class="nav-item-custom"
          v-has-permission.permission="['REP', 'VI']"
        >
          <router-link
            id="linkPopReport"
            class="a-sidebar"
            to="/popreport"
            @click.native="closeSidebar"
          >
            Relatório de POP's</router-link
          >
        </div>
        <div
          class="nav-item-custom"
          v-has-permission.permission="['FUN', 'VI']"
        >
          <router-link
            id="linkFunnel"
            class="a-sidebar"
            to="/funnel"
            @click.native="closeSidebar"
          >
            Funil de vendas</router-link
          >
        </div>
        <div class="dropdown-divider _divider-menu"></div>
        <div
          class="nav-item-custom"
          v-has-permission.permission="['ORG', 'VI']"
        >
          <router-link
            id="linkWebOrganizer"
            class="a-sidebar"
            to="/webOrganizer"
            @click.native="closeSidebar"
          >
            Organizador de rede</router-link
          >
        </div>
        <div class="nav-item-custom">
          <a href="#" @click.prevent="handleExit" class="a-sidebar">Sair</a>
        </div>
      </div>
    </div>
  </div>

  <b-modal
    id="appInstallModal"
    v-model="installModal.visible"
    centered
    hide-header-close
    no-close-on-backdrop
    :title="installModalContent ? installModalContent.title : ''"
    @hide="onInstallModalHide"
  >
    <template #modal-header>
      <h6 class="m-0"><strong>{{ installModalContent && installModalContent.title }}</strong></h6>
    </template>

    <div v-if="installModalContent">
      <p v-if="installModalContent.message">{{ installModalContent.message }}</p>
      <ol v-if="installModalContent.steps && installModalContent.steps.length">
        <li v-for="(step, index) in installModalContent.steps" :key="index">{{ step }}</li>
      </ol>
      <p v-if="installModalContent.note" class="text-muted small mb-0">{{ installModalContent.note }}</p>
    </div>

    <template #modal-footer>
      <b-button size="sm" variant="codemaps" @click="installModal.visible = false">Entendi</b-button>
    </template>
  </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { sendLogout, sucessMessage, infoMessage } from "../MessageBus";

function isRunningStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true ||
    document.referrer.startsWith("android-app://")
  );
}

function isIosDevice() {
  const userAgent = window.navigator.userAgent || "";
  const isAppleTouchDevice = /iphone|ipad|ipod/i.test(userAgent);
  const isIpadOs13Plus =
    window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1;
  return isAppleTouchDevice || isIpadOs13Plus;
}

// Estado compartilhado do PWA fora do ciclo de vida do componente, pois o
// evento "beforeinstallprompt" pode disparar antes do SideBar ser montado.
const pwaInstallState = Vue.observable({
  deferredPrompt: null,
  isInstalled: isRunningStandalone(),
});

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  pwaInstallState.deferredPrompt = event;
});

window.addEventListener("appinstalled", () => {
  pwaInstallState.deferredPrompt = null;
  pwaInstallState.isInstalled = true;
  sucessMessage("Aplicativo instalado com sucesso!");
});

const INSTALL_INSTRUCTIONS = {
  installed: {
    title: "Aplicativo já instalado",
    message:
      "Você já tem o Codemaps instalado neste dispositivo. Para abri-lo, procure pelo ícone na tela inicial ou na lista de aplicativos.",
    steps: [],
  },
  ios: {
    title: "Instalar no iPhone/iPad",
    message: null,
    steps: [
      "Toque no ícone de compartilhamento (quadrado com uma seta para cima) na barra do navegador.",
      'Deslize a lista de opções e toque em "Adicionar à Tela de Início".',
      'Toque em "Adicionar" no canto superior direito.',
    ],
    note:
      "No Safari essa opção fica direto na barra de compartilhamento. Em outros navegadores do iPhone/iPad, procure a mesma opção dentro do menu de compartilhamento.",
  },
  unsupported: {
    title: "Instalação não disponível neste navegador",
    message: "Não conseguimos iniciar a instalação automática. Você ainda pode tentar:",
    steps: [
      "Verificar se o aplicativo foi instalado anteriormente",
      "Recarregar a página e tentar novamente.",
      'Procurar a opção "Instalar aplicativo" ou "Adicionar à tela inicial" no menu do navegador (≡ ou ⋮).',
      "Usar um navegador atualizado, como Google Chrome ou Microsoft Edge.",
    ],
  },
  error: {
    title: "Não foi possível instalar",
    message:
      "Ocorreu um erro ao tentar instalar o aplicativo. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o suporte.",
    steps: [],
  },
};

export default {
  name: "SideBar",
  data() {
    return {
      visible: false,
      isVisible: true,
      installModal: {
        visible: false,
        case: null,
      },
    };
  },
  computed: {
    isAppInstalled() {
      return pwaInstallState.isInstalled;
    },
    appInstallLabel() {
      return this.isAppInstalled ? "App instalado" : "Download APP";
    },
    installModalContent() {
      return this.installModal.case ? INSTALL_INSTRUCTIONS[this.installModal.case] : null;
    },
  },
  methods: {
    closeSidebar() {
      this.isVisible = false;
      setTimeout(() => {
        this.$emit("close");
      }, 300);
    },
    handleExit() {
      sendLogout();
      this.closeSidebar();
    },
    ...mapActions({
      logout: "logout",
      setFolderSecundary: "setFolderSecundary",
      setFolder: "setFolder",
    }),
    openInstallModal(caseName) {
      this.installModal.case = caseName;
      this.installModal.visible = true;
    },
    onInstallModalHide() {
      this.installModal.case = null;
      this.closeSidebar();
    },
    async handleAppInstallClick() {
      if (this.isAppInstalled) {
        this.openInstallModal("installed");
        return;
      }

      if (isIosDevice()) {
        this.openInstallModal("ios");
        return;
      }

      const promptEvent = pwaInstallState.deferredPrompt;
      if (!promptEvent) {
        this.openInstallModal("unsupported");
        return;
      }

      pwaInstallState.deferredPrompt = null;

      try {
        await promptEvent.prompt();
        const { outcome } = await promptEvent.userChoice;

        this.closeSidebar();
        if (outcome === "accepted") {
          sucessMessage("Instalação iniciada, aguarde a conclusão.");
        } else {
          infoMessage("Instalação cancelada.");
        }
      } catch (error) {
        console.error("Erro ao instalar aplicativo:", error);
        this.openInstallModal("error");
      }
    },
  },
};
</script>

<style scoped>
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  justify-content: flex-end;
  /* Garantir que os eventos de clique funcionem */
  pointer-events: auto;
}

.sidebar-main {
  width: 320px;
  height: 100%;
  background-color: #020f40;
  color: #fff;
  overflow-y: auto;
  transform: translateX(0);
  transition: transform 0.3s ease-in-out;
  /* Garantir que cliques no sidebar não fechem o menu */
  pointer-events: auto;
}

.sidebar-body {
  padding: 2rem;
}

._divider-menu {
  border-top: 1px solid #4f555a;
}

/* Replicando o comportamento do b-card */
.card-custom {
  background-color: transparent;
  border: 0px;
  margin-bottom: 0.25rem;
}

.card-header-custom {
  background-color: transparent;
  border: none;
  padding: 0.25rem;
}

.card-body-custom {
  padding: 1rem;
  background-color: transparent;
}

/* Collapse manual */
.collapse-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
}

.collapse-content.show {
  max-height: 1000px;
}

/* Replicando o comportamento do b-nav-item */
.nav-item-custom {
  display: block;
}

.nav-item-custom a {
  text-decoration: none;
  display: block;
  color: #fff;
  padding: 0.5rem 0;
}

.a-sidebar {
  color: #fff !important;
  text-decoration: none;
}

.a-sidebar:hover {
  color: #0188f8 !important;
}

/* Mantendo os estilos originais */
.sidebar-button {
  color: white;
  font-weight: 600;
  background: transparent;
  border: none;
  text-align: left;
}

.sidebar-button:hover {
  color: #0188f8;
  background: transparent;
}

.btn-transparent {
  background: transparent !important;
  border: none !important;
}

.btn-transparent:focus {
  box-shadow: none !important;
}

/* Accordion customizado */
.accordion-custom {
  --bs-accordion-border-width: 0;
  --bs-accordion-border-radius: 0;
}

/* Responsividade */
@media (max-width: 768px) {
  .sidebar-main {
    width: 280px;
  }
}

@media (max-width: 480px) {
  .sidebar-main {
    width: 100%;
  }
}
</style>
